/**
 * @file HeaderUserMenu.tsx
 * @module _admin/partials/layout/header-menus/HeaderUserMenu
 * @description Renders the HeaderUserMenu menu component for header notifications, language selection, or account actions.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from "react";
import { useAuth } from "../../../../app/modules/auth";
import APICallService from "../../../../api/apiCallService";
import { LOGOUT } from "../../../../api/apiEndPoints";

const HeaderUserMenu: FC = () => {
  const { currentUser, logout } = useAuth();
  const handleLogout = async () => {
    let apiService = new APICallService(LOGOUT);
    await apiService.callAPI();
    await logout();
  };

  return (
    <div
      className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-900 menu-state-bg menu-state-primary fw-500 fs-16 w-200px py-2"
      data-kt-menu="true"
    >
      {(currentUser?.name || currentUser?.email) && (
        <div className="px-5 pb-2 border-bottom">
          {currentUser?.name && (
            <div className="fw-bold text-dark fs-6 text-truncate">
              {currentUser.name}
            </div>
          )}

          {currentUser?.email && (
            <div className="text-muted fs-7 text-truncate">
              {currentUser.email}
            </div>
          )}
          {currentUser?.roleAndPermission?.name && (
            <div className="text-muted fs-7 text-truncate">
              {currentUser?.roleAndPermission?.name}
            </div>
          )}

          {currentUser?.userType === 2 && currentUser?.role[0]?.type === 1 && (
            <div className="text-muted fs-7 text-truncate">Sales Manager</div>
          )}
          {currentUser?.userType === 2 && currentUser?.role[0]?.type === 2 && (
            <div className="text-muted fs-7 text-truncate">Sales Representative</div>
          )}
          {currentUser?.userType === 2 && currentUser?.role[0]?.type === 6 && (
            <div className="text-muted fs-7 text-truncate">Activation Manager</div>
          )}
          {currentUser?.userType === 2 && currentUser?.role[0]?.type === 7 && (
            <div className="text-muted fs-7 text-truncate">Activation Representative</div>
          )}
        </div>
      )}

      {/* Sign Out */}
      <div className="menu-item px-3 pt-2">
        <a
          onClick={handleLogout}
          className="menu-link px-3 py-1 text-black"
          style={{ cursor: "pointer" }}
        >
          Sign Out
        </a>
      </div>
    </div>
  );
};

export { HeaderUserMenu };
